import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createAttachments(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(EntityTypeEnum.Attachments, parentId, masterBlockId),
    show: false,
    alignSelf: 'flex-start',
    iconClassName: 'far fa-paperclip',
    fontSize: 20,
    color: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(1, 160, 255, 1)',
    slug: FieldSlugEnum.Attachments,
    border: {
      radius: 5,
      style: BorderStyleEnum.none,
    },
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 15,
      marginLeft: 0,
    },
  }
}
